export class TrainApiError extends Error {
    constructor(message, status) {
        super(message);
        this.status = status;
        this.name = 'TrainApiError';
    }
}
export class TrainApiClient {
    constructor(config) {
        if (!config.baseUrl) {
            throw new Error('TrainApiClient: baseUrl is required. Set NEXT_PUBLIC_TRAIN_API env var.');
        }
        this.baseUrl = config.baseUrl.replace(/\/$/, '');
    }
    async getNetworks() {
        const data = await this.request('GET', '/networks');
        return (data.data ?? []);
    }
    async getPrices() {
        const data = await this.request('GET', '/prices');
        return data.data ?? {};
    }
    async getOrder(hashlock, solverAddress) {
        const query = solverAddress ? `?solverAddress=${encodeURIComponent(solverAddress)}` : '';
        const data = await this.request('GET', `/orders/${encodeURIComponent(hashlock)}${query}`);
        return data.data;
    }
    async revealSecret(hashlock, secret, solverAddress) {
        const query = solverAddress ? `?solverAddress=${encodeURIComponent(solverAddress)}` : '';
        const params = { secret };
        await this.request('POST', `/orders/${encodeURIComponent(hashlock)}/reveal-secret${query}`, params);
    }
    async getQuote(params) {
        const { includeReward = true, sourceTokenContract, destinationTokenContract, ...rest } = params;
        const urlParams = new URLSearchParams({
            ...rest,
            includeReward: String(includeReward),
        });
        if (sourceTokenContract)
            urlParams.set('sourceTokenContract', sourceTokenContract);
        if (destinationTokenContract)
            urlParams.set('destinationTokenContract', destinationTokenContract);
        const query = urlParams.toString();
        const data = await this.request('GET', `/quote?${query}`);
        return data.data;
    }
    async request(method, path, body) {
        const url = `${this.baseUrl}/api/v1${path}`;
        const res = await fetch(url, {
            method,
            headers: {
                'Content-Type': 'application/json',
            },
            ...(body !== undefined ? { body: JSON.stringify(body) } : {}),
        });
        if (!res.ok) {
            const text = await res.text().catch(() => res.statusText);
            throw new TrainApiError(`${method} ${path} failed (${res.status}): ${text}`, res.status);
        }
        return res.json();
    }
}
